import styled, { css } from 'styled-components'

import { CustomButton } from '../../../styles/global'
import { CardContainer, CardSkeleton } from '../../../components/Card/styles'
import { Container as LoadMoreContainer } from '../../../components/LoadMore/styles'

export const Container = styled.div`
  display: flex;
  width:100%;
  border-top: 1px solid #DADADA;
`

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`

export const HeaderInfo = styled.section`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 24px;
`

export const Title = styled.h2`
  font-family: 'Open Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28.8px;
  margin-bottom: 0;
  color: #222;
`

export const Main = styled.section`
  display: flex;
  padding: 0px 24px;
  justify-content: center;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #DADADA;
  `

export const List = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  padding: 24px 0px;
  flex-direction: column;
  gap: 24px;
  flex: 1 0 0;

  ${LoadMoreContainer}{
    margin-top: 0;
  }
`

export const StyledCard = styled.div`
  display: flex;
  height: 100%;
  cursor: pointer;

  ${CardContainer}{
    flex-direction: row;
    justify-content: space-between;
    box-sizing: border-box;
    align-items: center;
    width: 100%;
    border: 1px solid #DADADA;
    box-shadow: none;
    gap: 16px;
  }
  ${CardSkeleton}{
    min-height: 137px;

    span {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
`

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 56%;
  max-width: 100%;
`

export const Subtitle = styled.h2`
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.96px;
  margin-bottom: 4px;
  color: #222;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;

  ${({ isRead }) => isRead && css`
    font-weight: 400;
  `}
`

export const Text = styled.p`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  margin: 0 0 8px 0;
  color: #555;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  white-space: pre-wrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
`

export const Avatar = styled.img`

`

export const ButtonOpen = styled.button`
  margin:0 auto;
  border:none;
  background:none;
`

export const ButtonToClose = styled(ButtonOpen)`

`

export const DateField = styled.div`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  color: #555;
`

export const Button = styled(CustomButton)`
`

export const WarningLabel = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  padding: 2px 8px 3px;
  background-color: #FAECCA;
  margin-bottom: 11px;
  border-radius: 8px;
  gap: 5px;
`

export const WarningText = styled.h2`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
  color: #CE9400;
  margin-bottom: 0;
`
